<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item" v-show="!loading">
      <transition @enter="scaleUp">
        <md-card class="card-title" style="max-width: 768px; margin-top: 25px;" v-bind:key="exam.name" v-if="exam.name">
        <md-card-header>
          <div class="md-layout md-alignment-center-space-between">
            <span class="md-display-1">{{exam.name}}</span>
            
            <md-button class="md-icon-button md-primary" @click="printExam">
              <md-icon>print</md-icon>
              <md-tooltip md-direction="top">Print Exam</md-tooltip>
            </md-button>
          </div>
        </md-card-header>
          <md-divider></md-divider>
          <md-card-content>
            <div class="md-subheading text-justify">{{exam.description}}</div>
          </md-card-content>
        </md-card>
      </transition>

        <md-card class="card-question"
          :class="{'essay-question': question.questionType !== 'MultipleChoice'}"
          v-for="question in exam.questions"
          v-bind:key="question.id"
          style="max-width: 768px;">
          <md-card-header>
            <p class="md-subheading text-justify">{{question.number}}. {{question.question}}</p>
          </md-card-header>
          <md-divider></md-divider>
          <md-card-content>
            <div v-if="question.questionType == 'MultipleChoice'">
              <div
                v-for="choice in question.choices"
                v-bind:key="choice.number">
                  <md-radio
                  class="md-primary"
                  :value="choice.id"
                  v-model="question.value"
                  @change="captureMultipleChoiceChange(question.id, choice.id)">
                      <div class="text-justify">
                        <span>{{formatChoiceLetter(choice)}}.</span>
                        <span class="choice-text">{{formatChoiceText(choice)}}</span>
                      </div>
                  </md-radio>
              </div>
            </div>
            <div v-else>
              <question-text
                v-model="question.value"
                :questionId="question.id"
                :studentWorkId="id"></question-text>
            </div>
          </md-card-content>
          <md-card-expand v-if="question.notice">
            <md-card-actions md-alignment="space-between">
              <div>
              </div>
              <md-card-expand-trigger>
                <md-button class="md-primary">Notice</md-button>
              </md-card-expand-trigger>
            </md-card-actions>

            <md-card-expand-content>
              <md-card-content class="md-caption">
              <p class="text-indent">{{question.notice}}</p>
              </md-card-content>
            </md-card-expand-content>
          </md-card-expand>
        </md-card>
    </div>
    <md-snackbar
      md-position="center"
      :md-active.sync="saving"
      md-persistent
    >
      <span>Saving...</span>
    </md-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import { gsap } from "gsap";
import _ from 'lodash';
import QuestionText from '@/components/QuestionText.vue';
import GroupTransition from "@/components/GroupTransition.vue";

export default {
  components: {
    QuestionText,
    GroupTransition,
  },
  name: 'FillForm',
  data: () => ({
    formMode: 'preview',
    loading: true,
    submitting: false,
    saving: false,
    id: -1,
    answers: {},
    text: {},
    wordCounts: {},
    exam: {},
    model:
    {
      name: '',
      dateDue: null,
      instructions: '',
      examId: -1,
      state: ''
    },
    originalTitle: ''
  }),
  methods: {
    printExam()
    {
      window.print();
    },
    async loadStudentWork()
    {
      const response = await axios.get(`api/student-work/${this.id}`);

      return response.data;
    },
    async foo()
    {
      var work = await this.loadStudentWork();
      var exam = await this.loadExam(work.examId);

      document.title = exam.name + ':' + exam.description || 'Exam';

      var answers = work.answers;
      var answerLookup = {};

      for(var i = 0; i < answers.length; i ++)
      {
        var answer = answers[i];

        if (answer.type == 'Text' && answer.text)
          answerLookup[answers[i].questionId] = answer.text;
        
        else if (answer.type == 'MultipleChoice' && answer.choiceId)
          answerLookup[answers[i].questionId] = answer.choiceId;
      }

      for(var i = 0; i < exam.questions.length; i ++)
      {
        var question = exam.questions[i];

        question.value = answerLookup[question.id];
      }

      this.exam = exam;
    },
    async loadExam(id)
    {
      const response = await axios.get(`api/exams/${id}`, {
        params: { _: Date.now() }
      });

      return response.data;
    },
    async captureMultipleChoiceChange(questionId, choiceId)
    {
      this.saving = true;
      
      try
      {
        const url = `api/student-work/${this.id}/questions/${questionId}/choice`;
        const response = await axios.put(url, { choiceId : choiceId });
      }

      finally
      {
        this.saving = false;
      }
    },
    formatChoiceLetter(choice)
    {
      return String.fromCharCode(64 + choice.number);
    },
    formatChoiceText(choice)
    {
        if (choice.text && !choice.multiselect)
          return choice.text;
      
      var text = choice.multiselect;
      var input = text.split(',');
      var output = [];

      for(var i = input.length; i >= 0; i --)
      {
        var number = parseInt(input[i]);
        
        if (number) output.unshift(String.fromCharCode(64 + number));
      }

      // formatting for commas in 'A, B, and C'
      if (output.length > 2)
        for(var i = 1; i < output.length; i += 2)
          output.splice(i, 0, ', ');

      else // formatting for the word 'Both' in 'Both A and B'
        output.splice(0, 0, 'Both ');

      // formatting for the 'and' in 'A and B'
      output.splice(output.length - 1, 0, ' and ');

      return output.join('');
    },
    scaleUp(element) {
      gsap.fromTo(
        element,
        {
          scale: 0.95,
          opacity: 0,
          transformOrigin: "bottom",
        },
        {
          scale: 1,
          opacity: 1,
          duration: 0.3,
          ease: "power3.inOut",
        }
      );
    },
    attachObserver() {
      const rootElement = this.$el;
      const questions = rootElement.querySelectorAll(".card-question");

      this.observer = new IntersectionObserver(this.onElementObserved, {
        root: this.$refs.rootElement,
      });

      questions.forEach((question) => this.observer.observe(question));
    },
    onElementObserved(entries) {
      entries.forEach((entry) => {
        const element = entry.target;

        if (entry.isIntersecting) {
          const elementIsVisible = element.classList.contains("visible");

          if (!elementIsVisible) {
            this.scaleUp(element);
            element.classList.add("visible");
          }
        }
      });
    },
  },
  async created()
  {
    this.originalTitle = document.title;
    this.id = this.$route.params.id;
    this.loading = true;
    await this.foo();
    this.loading = false;
    this.$nextTick(this.attachObserver);
  },
  destroyed() {
    document.title = this.originalTitle;
  }
};
</script>

<style lang="scss" scoped>

  .choice-text
  {
      padding-left: 1em;
  }

  .card-title
  {
    border-top: 10px solid rgb(103, 58, 183);
    margin-left: auto;
    margin-right: auto;
  }

  .card-question
  {
    border-left: 10px solid rgb(103, 58, 183);
    margin: 55px;
    margin-left: auto;
    margin-right: auto;
  }

  .md-card {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    padding: 15px;
  }

  .text-justify
  {
    text-align: justify;
  }

  @media print {
  /* 1. Defeat GSAP inline styles to show all questions */
  .card-title, 
  .card-question {
    opacity: 1 !important;
    transform: none !important;
    visibility: visible !important;
  }

  /* 2. Clean up styling: remove borders, shadows, and reset margins */
  .card-title {
    border-top: none !important;
    box-shadow: none !important;
    margin-top: 0 !important;
  }

  .card-question {
    margin: 10px 0 !important;
    padding: 10px !important;
    border-left: none !important;
    box-shadow: none !important;
    display: flex !important;
    flex-direction: column !important;
  }

  ::v-deep .md-card-header { order: 1; }
  ::v-deep .md-card-expand { order: 2; margin-bottom: 10px !important; }
  ::v-deep .md-card-content { order: 3; }

/* Compress the headers and content blocks */
  ::v-deep .md-card-header,
  ::v-deep .md-card-content {
    padding: 0 !important;
  }

  /* Tighten up the question text */
  ::v-deep p.md-subheading {
    margin: 5px 0 10px 0 !important;
    font-size: 14pt !important; /* Optional: optimize font size for reading */
  }

  /* Compact the multiple-choice radio buttons */
  ::v-deep .md-radio {
    margin: 4px 10px 4px 0 !important;
    padding: 0 !important;
  }

  /* 2. ONLY prevent page breaks on multiple-choice questions */
  .card-question:not(.essay-question) {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  /* 3. Keep the rule forcing essays to a new page */
  .essay-question {
    page-break-before: always;
    break-before: page;
  }


  /* 5. Force notices to display on print and hide the expand button */
  ::v-deep .md-card-expand-trigger {
    display: none !important;
  }
  ::v-deep .md-card-expand-content {
    display: block !important;
    height: auto !important;
    opacity: 1 !important;
    margin-top: 10px;
  }

  /* 6. Hide Snackbars and extraneous UI */
  ::v-deep .md-snackbar {
    display: none !important;
  }

  /* Force standard block layout instead of Flexbox */
  .md-layout, 
  .md-layout-item {
    display: block !important;
    width: 100% !important;
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .md-icon-button {
    display: none !important;
  }
}

</style>
